
import { defineComponent } from "vue";
import { ITeachersModel } from "@/interfaces/modules";
import TeachersService from "@/api/Aula/TeachersService";
import store from "@/store";
import router from "@/router";

export default defineComponent({
  name: "App",
  data() {
    return {
      form: {
        loading: true,
        dialog: false,
        valid: false,
        record: {} as ITeachersModel,
        rules: {
          required: [(v: any) => !!v || "Este campo es requerido"],
        },
      },
      table: {
        filters: {
          search: "",
        },
        currentPage: 1,
        loading: false,
        headers: [
          {
            key: "Name",
            label: "Nombre",
            sortable: true,
          },
          {
            key: "LastName",
            label: "Apellido",
            sortable: true,
          },
          {
            key: "IdentificationNumber",
            label: "Identificación",
            sortable: true,
          },
          {
            key: "WorkEmail",
            label: "Email",
            sortable: true,
          },
          {
            key: "PrimaryPhone",
            label: "Teléfono",
            sortable: true,
          },
          {
            key: "Enable",
            label: "Activo",
            sortable: true,
          },

          {
            key: "CreatedByFormat",
            label: "Creación",
            sortable: true,
          },
          {
            key: "ModifiedByFormat",
            label: "Ultima modificación",
            sortable: true,
          },
          {
            key: "action",
            label: "Acciones",
            sortable: false,
          },
        ],
        records: [],
        rowsPerPage: 10,
      } as any,
    };
  },
  computed: {
    filteredItems(): any {
      return this.table.filters.search
        ? this.table.records.filter(
          (item: any) =>
            item.Name.toLowerCase().includes(
              this.table.filters.search.toLowerCase()
            ) ||
            item.LastName.toLowerCase().includes(
              this.table.filters.search.toLowerCase()
            )
        )
        : this.table.records;
    },
    formRecord(): any {
      return this.$refs.formRecord;
    },
    rows(): any {
      return this.table.records?.length || 0;
    },
  },
  mounted() {
    this.load();
  },
  methods: {
    async load() {
      this.table.loading = true;
      this.table.records = await TeachersService.GetTeachers();
      this.table.loading = false;
    },
    async edit(data: ITeachersModel) {
      router.push(`teacher-detail/${data.Id}`);
    },
    async newRecord() {
      router.push('teacher-detail/0');
    },

    openModal() {
      this.form.record = { Enable: true } as ITeachersModel;
      this.form.dialog = true;
    },

    async handleSubmit(event) {
      event.preventDefault();
      this.form.dialog = false;
      await TeachersService.PostTeachers(this.form.record);
      store.dispatch("core/popupDialog", {
        text: "Registro completado con éxito.",
        type: "success",
        showCancelButton: false,
      });
      this.load();
    },
  },
});
